import { useEffect, useMemo, useSyncExternalStore } from 'react'
import { useAuth } from '../App'
import { supabase } from '../lib/supabase'
import { createHomeGatewayPreferencesRepository } from '../lib/homeGatewayPreferencesRepository'
import { createHomeGatewayPreferencesStore } from '../lib/homeGatewayPreferencesStore'

const repository = createHomeGatewayPreferencesRepository(supabase)

// `mergeDefaults` names a definite state, not a guess: pass true only once the
// collection has loaded (Accord defaults derive from it) and the surface that
// renders the merged tiles is on. The read itself never depends on the
// collection, so collection updates do not refetch or flash the defaults.
export function useHomeGatewayPreferences({ fragrances = [], mergeDefaults = false } = {}) {
  const { user } = useAuth()
  // Change identity during render, so even the first frame uses safe defaults.
  const store = useMemo(() => createHomeGatewayPreferencesStore(user?.id, repository), [user?.id])
  const state = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot)
  useEffect(() => {
    void store.refresh()
    return () => store.deactivate()
  }, [store])
  const ready = mergeDefaults && !state.loading && state.customized
  useEffect(() => {
    if (ready) void store.applyDefaults(fragrances)
  }, [store, ready, fragrances])
  return { ...state, save: store.save, refresh: store.refresh }
}
